export const load = () => ({
	h1: 'IndowONE Lifetime Residential Warranty',
	title: 'IndowONE Lifetime Coverage For Residential Use',
	description:
		"Understand what is and isn't covered by the Indow Windows lifetime warranty for residential projects.",
	showTitle: false,
});
